import convertToyyyyMMdd from "../../../utils/conversions/dates/yyyyMMdd.date.conversion.util";

const DEFAULT_CLASSNAMES = {
  td: "w-full",
  input: "w-full font-ubuntuRegular shadow h-[36px] text-center p-1 rounded",
};

const TableDatePickerInput = ({
  classNames = DEFAULT_CLASSNAMES,
  value,
  ...otherProps
}) => {
  const convertedValue = convertToyyyyMMdd(value);
  return (
    <td className={classNames.td}>
      <input
        value={convertedValue}
        type="date"
        {...otherProps}
        className={classNames.input}
      />
    </td>
  );
};

export default TableDatePickerInput;
